import { FormGroup, FormControl, Validators } from '@angular/forms';
import { findIndex, find } from 'lodash';
import { Component, OnInit, Input, EventEmitter, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import {
  Context,
  Tarea,
  DynamicComponentForm,
  ConfigFinishDefault,
  TaskEvent,
  Const,
  ConfirmComponent,
  Condicion,
  Static,
  TareaCondicion,
  BaseControl,
  Opcion,
  Liquidacion,
  Option,
  Documento,
  FuncionDocumento,
  DocumentoDetalle,
  HistorialDocumento,
  RevisionDocumento
} from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { SelectedOption } from '../condition-form/condition-form.component';
import { LiquidationDeterminationFormService } from './shared/liquidation-determination.form.service';
import { LiquidationDeterminationDataService } from './shared/liquidation-determination.data.service';
import { Subject } from 'rxjs';

type OpcionConsignacionSeleccionada = 'Sí' | 'No';

@Component({
  selector: 'iw-liquidation-determination',
  templateUrl: './liquidation-determination.component.html',
  styleUrls: ['./liquidation-determination.component.scss'],
  providers: [LiquidationDeterminationFormService, LiquidationDeterminationDataService]
})
export class LiquidationDeterminationComponent extends DynamicComponentForm implements OnInit, OnDestroy {

  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<any>;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Define la finaliacioncion de la tarea
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // Activa el btn de finalizar si hay una opción seleccionada
  isDisabledBtnFinish = true;
  // Define cuando estan completos los documentos a subir en la tarea
  docComplete = true;
  // Variable que activa el gift de cargando cuando se está finalizando
  isLoadingFinish = false;
  // Define si el formulario de liquidacion esta guardado
  saveForm = false;
  // Define cuando existe ya una asociacion para el expediente
  exitAssociation = false;
  // Define si lleva documentos
  documents = false;
  // Define si lleva condicion de auxilio de pobreza
  condictionAuxilio = false;
  // Define cuando esta en la vista de documentos o en la de la tarea
  wimdowDocs = false;
  // Extensiones de los archivos permitidas
  extensions: Array<String> = ['jpg', 'png', 'pdf', 'xlsx', 'xls', 'docx', 'tiff', 'tif', 'doc'];
  // Variable que define si tiene consignacion
  consignment: OpcionConsignacionSeleccionada;
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // condición consignación
  consignmentCondition: Condicion;
  // Controles del formulario de liquidacion
  controls: BaseControl<any>[] = [];
  // Condiciones de la tarea
  condictions: Condicion[] = [];
  // Contiene las liquidaciones
  liquidations: Liquidacion[] = [];
  // Contiene las liquidaciones
  liquidationsSelect: Liquidacion;
  // Formulario de liquidacion
  formConsignment: FormGroup = new FormGroup({
    cboCondiction: new FormControl(-1, [Validators.required]),
  });
  // Formulario de liquidacion
  formLiquidation: FormGroup;
  // Tarea actual
  private _task: Tarea;
  // Opciones seleccionadas de el resto de condiciones
  private _selectedOptions: SelectedOption[] = [];
  // Opcion seleccionada de la condición consignación
  private _selectedOptionsConsignment: SelectedOption;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select para las columnas de formularios o maestras
  @ViewChild('ngSelect') private ngSelectTpl: TemplateRef<any>;

  constructor(
    private ldfs: LiquidationDeterminationFormService,
    private ldds: LiquidationDeterminationDataService,
    private toastr: ToastrService
  ) {
    super();
  }

  ngOnInit() {
    if(this.previewFlow){
      this.finishTask = true;
    }
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }
    this.validationCondiction();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  // Tarea actual
  set task(t: Tarea) {
    this._task = t;
    const condictionsAll = Static.getMapConditions(<TareaCondicion[]>t.tarea_condicion);
    if (condictionsAll && condictionsAll.length) {
      condictionsAll.forEach(condiction => {
        const condictionText = condiction.condicion;
        let optionSelect: Opcion;
        condiction.opciones.forEach(option => {
          if (option.seleccionado) {
            optionSelect = option;
          }
        });
        if (condiction.alias === 'condicion_general') {
          this.consignmentCondition = Static.copyObjet(condiction);
          if (optionSelect) {
            this.formConsignment.controls['cboCondiction'].setValue(optionSelect.id_opcion);
            this._selectedOptionsConsignment = {
              condicion: condictionText,
              opcion: optionSelect.id_opcion
            };
            const textOpcion = optionSelect.opcion.trim().toLowerCase();
            if (textOpcion === 'sí' || textOpcion === 'si') {
              this.consignment = 'Sí';
              this.consultLiquidationFile();
            } else {
              this.consignment = 'No';
            }
          } else {
            this.consultLiquidationFile();
          }
        } else {
          this.condictions.push(condiction);
          if (optionSelect) {
            this._selectedOptions.push({
              condicion: condictionText,
              opcion: optionSelect.id_opcion
            });
            if (condiction.alias === 'auxilio_pobreza') {
              this.condictionAuxilio = true;
              const textOptinA = optionSelect.opcion.trim().toLowerCase();
              if (textOptinA === 'sí' || textOptinA === 'si') {
                this.documents = true;
              } else {
                this.documents = false;
              }
            }
          }
        }
      });
      if (
        (
          this._selectedOptionsConsignment &&
          this._selectedOptionsConsignment.opcion
        ) &&
        (
          this.condictions.length === this._selectedOptions.length ||
          this.consignment === 'Sí'
        )
      ) {
        this.isDisabledBtnFinish = false;
      }
    }
    this.validDocs();
  }
  get task() {
    return this._task;
  }

  /**
   * Controla y guarda las opciones seleccionadas en las diferentes condiciones de la tarea
   * Realiza tambien el control de cambio de los formularios con la condicion de tiene consignacion
   *
   * @param {number} idOption
   * @param {Condicion} condition
   * @param {boolean} [consignment=false]
   * @memberof LiquidationDeterminationComponent
   */
  selectedOption(idOption: number, condition: Condicion, consignment: boolean = false) {
    if (consignment) {
      // Almacenar la opción seleccionada
      const option: SelectedOption = {
        condicion: condition.condicion,
        opcion: Number(idOption)
      };
      this._selectedOptionsConsignment = option;
      // Indicar la opcion seleccionada para la consignacion
      const optionSelect = find(condition.opciones, {id_opcion: Number(idOption)});
      if (optionSelect) {
        const textOpcion = optionSelect.opcion.trim().toLowerCase();
        if (textOpcion === 'sí' || textOpcion === 'si') {
          this.consignment = 'Sí';
        } else {
          this.consignment = 'No';
          this.saveForm = false;
          this.liquidationsSelect = null;
          this.formLiquidation = null;
        }
      }
    } else {
      // Almacenar la opción seleccionada
      const option: SelectedOption = {
        condicion: condition.condicion,
        opcion: Number(idOption)
      };
      const indexSelect = findIndex(this._selectedOptions, {
        condicion: condition.condicion
      });
      if (indexSelect !== -1) {
        this._selectedOptions[indexSelect] = option;
      } else {
        this._selectedOptions.push(option);
      }

      const indexCondiction = findIndex(this.condictions, {condicion: condition.condicion});

      if (indexCondiction !== -1) {
        const indexOptionSelect = findIndex(this.condictions[indexCondiction].opciones, {id_opcion: Number(idOption)});
        if (indexOptionSelect !== -1) {
          this.condictions[indexCondiction].opciones.forEach((el, i) => {
            if (i === indexOptionSelect) {
              el.seleccionado = true;
            } else {
              el.seleccionado = false;
            }
          });
        }
      }

      if (condition.alias === 'auxilio_pobreza') {
        const optionSelect = find(condition.opciones, {id_opcion: Number(idOption)});
        this.condictionAuxilio = true;
        const textOptinA = optionSelect.opcion.trim().toLowerCase();
        if (textOptinA === 'sí' || textOptinA === 'si') {
          this.documents = true;
          this.validDocs();
        } else {
          this.documents = false;
          this.docComplete = true;
        }
      }
    }

    // Validar si se activa o no el btn para finalizar la tarea
    if (
      (
        this._selectedOptionsConsignment &&
        this._selectedOptionsConsignment.opcion
      ) &&
      (
        this.condictions.length === this._selectedOptions.length ||
        this.consignment === 'Sí'
      )
    ) {
      this.isDisabledBtnFinish = false;
    } else {
      this.isDisabledBtnFinish = true;
    }
  }

  /**
   * Encapsula el formulario de liquidacion creado
   * y setea la informacion en el formulario si el expediente tiene una liquidacion asociada existente
   *
   * @param {FormGroup} form
   * @memberof LiquidationDeterminationComponent
   */
  formCreate(form: FormGroup) {
    this.formLiquidation = form;
    if (this.consignment === 'Sí' && this.liquidationsSelect) {
      this.formLiquidation.controls['cboCupon'].setValue(this.liquidationsSelect.idliq_liquidacion);
      this.formLiquidation.controls['numValorCancelado'].setValue(this.liquidationsSelect.valor_cancelado);
      this.formLiquidation.controls['numNumeroRecibo'].setValue(this.liquidationsSelect.numero_recibo);
      this.formLiquidation.controls['dtFechaRecibo'].setValue(this.liquidationsSelect.fecha_recibo);
      this.formLiquidation.controls['txtCodigoConvenio'].setValue(this.liquidationsSelect.codigo_convenio);
      this.formLiquidation.controls['cboCupon'].disable();
      this.saveForm = true;
      this.isDisabledBtnFinish = false;
    }
  }

  /**
   * Controla el cambio de cupon seleccionado para setear la informacion en los campos
   * correspondientes al cupon seleccionado
   *
   * @param {*} data
   * @memberof LiquidationDeterminationComponent
   */
  changeForm(data: any) {
    if (data.change) {
      if (data.change.cboCupon) {
        const liquidation = find(this.liquidations, {idliq_liquidacion: data.change.cboCupon});
        if (
          liquidation &&
          (!this.liquidationsSelect || this.liquidationsSelect.idliq_liquidacion !== liquidation.idliq_liquidacion)
        ) {
          this.liquidationsSelect = liquidation;
          this.formLiquidation.controls['numValorCancelado'].setValue(this.liquidationsSelect.valor_cancelado);
          this.formLiquidation.controls['numNumeroRecibo'].setValue(this.liquidationsSelect.numero_recibo);
          this.formLiquidation.controls['dtFechaRecibo'].setValue(this.liquidationsSelect.fecha_recibo);
          this.formLiquidation.controls['txtCodigoConvenio'].setValue(this.liquidationsSelect.codigo_convenio);
          this.saveForm = true;
        }
      } else if (this.liquidationsSelect) {
        this.saveForm = false;
        this.liquidationsSelect = null;
        this.formLiquidation.reset();
      }
    }
  }

  /**
   * Valida la informacion general de la tarea para bloquear el combo de la condicion tiene_consignacion
   *
   * @memberof LiquidationDeterminationComponent
   */
  validationCondiction() {
    if (!this.userResponsible || this.finishTask || this.task.fecha_finalizacion) {
      this.formConsignment.controls['cboCondiction'].disable();
    } else {
      this.formConsignment.controls['cboCondiction'].enable();
    }
  }

    /**
     * Abre el componente de documentos
     *
     * @memberof LiquidationDeterminationComponent
     */
    openDocs() {
      this.wimdowDocs = true;
    }

  /**
   * Cierra el componete de documentos
   *
   * @param {boolean} res
   * @memberof LiquidationDeterminationComponent
   */
  closeDocs(res: boolean) {
    if (res) {
      this.wimdowDocs = false;
    }
  }

  /**
   * actualiza la informacion de la tarea con respecto a los documentos subidos
   *
   * @param {Documento[]} data
   * @returns {*}
   * @memberof LiquidationDeterminationComponent
   */
  documentUpdate(data: Documento[]): any {

    data.forEach(newDoc => {
      // Copiando funciones del documento
      const functionD: FuncionDocumento[] = [];
      newDoc.funciones.forEach(fun => {
        functionD.push({
          funcion: fun.funcion,
          id_funcion: fun.id_funcion,
          obligatorio: fun.obligatorio
        });
      });
      // Copienado documentos detalle del documento
      const detailDocument: DocumentoDetalle[] = [];
      newDoc.documentos_detalle.forEach(detail => {
        // Copiando historial del docuemnto
        const record: HistorialDocumento[] = [];
        if (detail.historial && detail.historial.length) {
          detail.historial.forEach(history => {
            // Copiando revisiones del registro de historial del documento
            const revisions: RevisionDocumento[] = [];
            if (history.revision && history.revision.length) {
              history.revision.forEach(revision => {
                revisions.push({
                  id_revision: revision.id_revision,
                  id_tarea: revision.id_tarea,
                  reponsable_id: revision.reponsable_id,
                  nombre_tarea: revision.nombre_tarea,
                  descripcion: revision.descripcion,
                  nombre_responsable: revision.nombre_responsable,
                  apellidos_responsable: revision.apellidos_responsable,
                  fecha: revision.fecha,
                  revision: revision.revision,
                  historial_id: revision.historial_id,
                  version: revision.version,
                  opcion: revision.opcion
                });
              });
            }
            record.push({
              id: history.id,
              nombre: history.nombre,
              nombre_archivo: history.nombre_archivo,
              extension: history.extension,
              version: history.version,
              revision: revisions,
              radicado: history.radicado,
            });
          });
        }
        detailDocument.push({
          fecha: detail.fecha,
          folios: detail.folios,
          historial: record,
          id_documento: detail.id_documento,
          radicado: detail.radicado,
          documento_cita: detail.documento_cita,
          id_documento_cita: detail.id_documento_cita,
        });
      });
      // Copiando documento
      const doc: Documento = {
        clasificacion: newDoc.clasificacion,
        clasificacion_id: newDoc.clasificacion_id,
        codigo_documento: newDoc.codigo_documento,
        documentos_detalle: detailDocument,
        funciones: functionD,
        id_tipo_documental: newDoc.id_tipo_documental,
        id_expediente_cita: newDoc.id_expediente_cita,
        ruta_generacion: newDoc.ruta_generacion,
        ruta_vista_previa: newDoc.ruta_vista_previa,
        tipo_documental: newDoc.tipo_documental,
      };
      this.ctx.task.documentos.forEach((document, index) => {
        if (this.task.id === newDoc.idtarea && document.clasificacion_id === newDoc.clasificacion_id) {
          this.ctx.task.documentos[index] = doc;
        }
      });
      if (this.ctx.task.tarea_asociacion && this.ctx.task.tarea_asociacion.length) {
        this.ctx.task.tarea_asociacion.forEach(taskAssociation => {
          taskAssociation.documentos.forEach((document, index) => {
            if (
              taskAssociation.id_tarea_destino === newDoc.idtarea &&
              document.clasificacion_id === newDoc.clasificacion_id
            ) {
              taskAssociation.documentos[index] = doc;
            }
          });
        });
      }
    });
    this.updateTask(this.ctx.task);
    this.validDocs();
  }

  /**
   * Valida que todos los documentos se hayan subido y activa el boton de finalizar
   *
   * @memberof ProjectLiquidationComponent
   */
  validDocs() {
    if (this.documents) {
      let valid = true;
      if (this.task.documentos.length > 0) {
        for (let indexDoc = 0; indexDoc < this.task.documentos.length; indexDoc++) {
          let validUpload = false;
          if (this.task.documentos[indexDoc].funciones.length > 0) {
            for (let indexFuntion = 0;
              indexFuntion < this.task.documentos[indexDoc].funciones.length;
              indexFuntion++) {
              if (this.task.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.upload) {
                if (this.task.documentos[indexDoc].funciones[indexFuntion].obligatorio) {
                  validUpload = true;
                  break;
                }
              }
            }
          }
          if (validUpload) {
            if (this.task.documentos[indexDoc].documentos_detalle.length > 0) {
              if (this.task.documentos[indexDoc].documentos_detalle[0].hasOwnProperty('historial')) {
                if (this.task.documentos[indexDoc].documentos_detalle[0].historial.length > 0) {
                  const versionDoc = this.task.documentos[indexDoc].documentos_detalle[0].historial.length;
                  for (let indexHistory = 0;
                    indexHistory < this.task.documentos[indexDoc].documentos_detalle[0].historial.length;
                    indexHistory++) {
                    if (this.task.documentos[indexDoc]
                      .documentos_detalle[0].historial[indexHistory].version === versionDoc) {
                      if (this.task.documentos[indexDoc]
                        .documentos_detalle[0].historial[indexHistory].revision.length) {
                        let idReview = 0;
                        for (let indexReview = 0;
                          indexReview < this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory].revision.length;
                          indexReview++) {
                          if (this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory]
                            .revision[indexReview].id_revision > idReview) {
                            idReview = this.task.documentos[indexDoc]
                              .documentos_detalle[0].historial[indexHistory]
                              .revision[indexReview].id_revision;
                          }
                        }
                        for (let indexReview = 0;
                          indexReview < this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory].revision.length;
                          indexReview++) {
                          if (this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory]
                            .revision[indexReview].id_revision === idReview) {
                            if (!this.task.documentos[indexDoc]
                              .documentos_detalle[0].historial[indexHistory]
                              .revision[indexReview].revision) {
                              valid = false;
                              break;
                            } else {
                              valid = true;
                            }
                          }
                        }
                        if (!valid) {
                          break;
                        }
                      } else {
                        valid = true;
                      }
                    }
                  }
                } else {
                  valid = false;
                  break;
                }
              } else {
                valid = false;
                break;
              }
            } else {
              valid = false;
              break;
            }
          }
          if (!valid) {
            break;
          }
        }
      }
      if (valid) {
        if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
          for (const taskAssociation of this.task.tarea_asociacion) {
            if (taskAssociation.documentos.length > 0) {
              for (let indexDoc = 0; indexDoc < taskAssociation.documentos.length; indexDoc++) {
                let validUpload = false;
                if (taskAssociation.documentos[indexDoc].funciones.length > 0) {
                  for (let indexFuntion = 0;
                    indexFuntion < taskAssociation.documentos[indexDoc].funciones.length;
                    indexFuntion++) {
                    // tslint:disable-next-line: max-line-length
                    if (taskAssociation.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.upload) {
                      if (taskAssociation.documentos[indexDoc].funciones[indexFuntion].obligatorio) {
                        validUpload = true;
                        break;
                      }
                    }
                  }
                }
                if (validUpload) {
                  if (taskAssociation.documentos[indexDoc].documentos_detalle.length > 0) {
                    if (taskAssociation.documentos[indexDoc].documentos_detalle[0].hasOwnProperty('historial')) {
                      if (taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length > 0) {
                        const versionDoc = taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length;
                        for (let indexHistory = 0;
                          indexHistory < taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length;
                          indexHistory++) {
                          if (taskAssociation.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory].version === versionDoc) {
                            if (taskAssociation.documentos[indexDoc]
                              .documentos_detalle[0].historial[indexHistory].revision.length) {
                              let idReview = 0;
                              for (let indexReview = 0;
                                indexReview < taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory].revision.length;
                                indexReview++) {
                                if (taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory]
                                  .revision[indexReview].id_revision > idReview) {
                                  idReview = taskAssociation.documentos[indexDoc]
                                    .documentos_detalle[0].historial[indexHistory]
                                    .revision[indexReview].id_revision;
                                }
                              }
                              for (let indexReview = 0;
                                indexReview < taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory].revision.length;
                                indexReview++) {
                                if (taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory]
                                  .revision[indexReview].id_revision === idReview) {
                                  if (!taskAssociation.documentos[indexDoc]
                                    .documentos_detalle[0].historial[indexHistory]
                                    .revision[indexReview].revision) {
                                    valid = false;
                                    break;
                                  } else {
                                    valid = true;
                                  }
                                }
                              }
                              if (!valid) {
                                break;
                              }
                            } else {
                              valid = true;
                            }
                          }
                        }
                      } else {
                        valid = false;
                        break;
                      }
                    } else {
                      valid = false;
                      break;
                    }
                  } else {
                    valid = false;
                    break;
                  }
                }
                if (!valid) {
                  break;
                }
              }
              if (!valid) {
                break;
              }
            }
          }
        }
      }
      if (valid) {
        this.docComplete = true;
      } else {
        this.docComplete = false;
      }
    } else {
      this.docComplete = true;
    }
  }

  /**
   * Función que realiza las validaciones de la finalización.
   *
   * @param {boolean} res
   * @memberof LiquidationDeterminationComponent
   */
  async finish(res: boolean) {
    if (res) {
      this.isLoadingFinish = true;
      this.formConsignment.controls['cboCondiction'].disable();
      let data: ConfigFinishDefault;
      if (this.consignment === 'No' && this.condictions.length) {
        if (this._selectedOptions && this._selectedOptions.length === 1) {
          data = {
            tarea: this.task.id,
            id_opcion: this._selectedOptions[0].opcion
          };
        } else if (this._selectedOptions && this._selectedOptions.length) {
          const options: Array<number> = [];
          this._selectedOptions.forEach(el => {
            options.push(el.opcion);
          });
          data = {
            tarea: this.task.id,
            id_opciones: options
          };
        }
      } else {
        data = {
          tarea: this.task.id,
          id_opcion: this._selectedOptionsConsignment.opcion
        };
      }
      if (this.consignment === 'Sí' && !this.exitAssociation) {
        await this.ldds.associationLiquidationExpediente(this.task.id, this.liquidationsSelect.idliq_liquidacion)
          .then(resp => {
            if (resp) {
              const e: TaskEvent = {
                type: 'finish',
                data: data
              };
              this.event.emit(e);
              this.close();
            }
          }).catch(() => {
            this.isLoadingFinish = false;
            this.formConsignment.controls['cboCondiction'].enable();
          });
      } else {
        const e: TaskEvent = {
          type: 'finish',
          data: data
        };
        this.event.emit(e);
        this.close();
      }
    }
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof LiquidationDeterminationComponent
   */
  finishConfirm() {
    if (this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    } else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }

  /**
   * Cnsulta la liquidacion asociada a el expediente o las liquidaciones registradas con pago y sin expediente
   *
   * @private
   * @memberof LiquidationDeterminationComponent
   */
  private consultLiquidationFile() {
    this.ldds.getLiquidationsExpediente(this.task.id, true).subscribe(liquidations => {
      this.liquidations = liquidations;
      const options: Option[] = [];
      if (this.liquidations && this.liquidations.length) {
        this.liquidations.forEach(liquidation => {
          options.push({
            key: liquidation.cupon,
            value: liquidation.idliq_liquidacion
          });
        });
        if (this.liquidations.length === 1 && this.liquidations[0]['idexpediente']) {
          this.exitAssociation = true;
          this.liquidationsSelect = this.liquidations[0];
          this.consignment = 'Sí';
          let optionYes: Opcion;
          this.consignmentCondition.opciones.forEach(option => {
            const textOpcion = option.opcion.trim().toLowerCase();
            if (textOpcion === 'sí' || textOpcion === 'si') {
              optionYes = option;
            }
          });
          if (optionYes) {
            // Almacenar la opción seleccionada
            const option: SelectedOption = {
              condicion: this.consignmentCondition.condicion,
              opcion: Number(optionYes.id_opcion)
            };
            this._selectedOptionsConsignment = option;
            this.formConsignment.controls['cboCondiction'].setValue(optionYes.id_opcion);
            this.formConsignment.controls['cboCondiction'].disable();
          }
        }
      }
      this.controls = this.ldfs.getForm(this.ngSelectTpl, options);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/all/liquidation-determination/liquidation-determination.component.ts